// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"89":"5932dc77","94":"a892189b","369":"c77053fe","676":"72abc12a"}[chunkId] + ".js";
};